/**
 * @rehrig/tracking-sdk
 * Frontend tracking SDK for user activity analytics
 * 
 * This SDK provides:
 * - Event capture and queuing with offline support
 * - Batch transmission to backend API
 * - React integration via TrackingProvider and useTracking hook
 * - Type-safe event definitions
 */

// Core tracking functionality
export { TrackingClient } from './core/TrackingClient';
export { EventQueue } from './core/EventQueue';
export { BatchManager } from './core/BatchManager';

// Storage adapters
export { IndexedDBAdapter } from './storage/IndexedDBAdapter';
export { LocalStorageAdapter } from './storage/LocalStorageAdapter';
export { NoOpAdapter } from './storage/NoOpAdapter';

// React integration
export { TrackingProvider, TrackingContext } from './react/TrackingProvider';
export type { TrackingContextValue } from './react/TrackingProvider';
export { useTracking } from './react/useTracking';

// Type definitions
export * from './types/events';
export * from './types/config';
